import { Column } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import styled from "styled-components";

export const ProductBasedCollectionPageWrapper = styled(Column)`
  width: 100%;
  max-width: 1220px;
  margin: 0 auto;
  padding: ${getSpacing(0, "6x")};

  ${responsiveMediaQueries.mobile} {
    padding: 0;
  }
`;
